exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ {\n  color: #DC143Ced;\n  font-size: 12px; }\n  :host /deep/ p {\n    font-size: 12px;\n    line-height: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/field-error-message/field-error-message.component.scss
// module id = 1461
// module chunks = 18